<template>
  <div :class="$style['mobile-header']">
    <img src="@/assets/img/number/m_number-title.png" :class="$style['header-title']"/>
    <p :class="$style['header']">数字经济观察和数字人才培养</p>
    <img src="@/assets/img/number/m_bg_center.png" :class="$style['header-center']"/>
    <!-- <p :class="$style['header-btn']">进一步了解</p> -->
    <div :class="$style['header-desc']">
      <p :class="[isShow? $style['desc-show'] : $style['desc-up']]"> “双数”研究院是极客邦科技的核心研究机构，“双数”指研究院的主要研究方向：数字经济观察和数字人才培养。双数研究院的核心职能包括：数字经济观察、数字化人才培养研究与体系设计、数字化转型企业架构方法论研究与微咨询、数字经济研究、生态建设相关研究与实践，以及数字化转型案例发掘与推广。</p>
      <p :class="$style['header-action']" @click="show()">
        <span :class="$style['header-text']">{{isShow? '收起' : '展开'}}</span>
        <i class="iconfont icon-arrow"  :class="[{[$style['foucs']]: isShow}]"></i>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {
  },
  props: {
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    show () {
      this.isShow = !this.isShow
    }
  }
}
</script>
<style lang='scss' module>
.mobile-header {
  position: relative;
  box-sizing: border-box;
  width: 100%; height: 600px;
  padding-top: 40px;
  background-image: url('../../assets/img/number/m_bg.png');
  background-position: center;
  background-size: 100% 100%;
  text-align: center;

  & .header-title {
    width: 123px; height: 56px;
    margin: 0 auto;
  }
  & .header {
    width: 280px; line-height: 40px;
    margin: 16px auto 0;
    font-size: 30px;
    font-weight: 600;
    color: #404040;
  }
  & .header-center {
    margin-top: 20px;
  }
  // & .header-btn {
  //   width: 180px; height: 36px;
  //   line-height: 36px;
  //   background: linear-gradient(90deg, #2E7DFF 0%, #71A7FF 100%);
  //   border-radius: 21px;
  //   margin: 30px auto;
  //   font-size: 14px;
  //   font-weight: 500;
  //   color: #FFFFFF;
  // }
  & .header-desc {
    position: absolute; left: 50%; top: 500px;
    transform: translateX(-50%);
    box-sizing: border-box;
    width: 335px;
    padding: 20px 16px 51px;
    margin: 0 auto;
    background: url(../../assets/img/number/m-bg-box.png) no-repeat top 0 left 0 / 155px 154px, #fff;
    box-shadow: 0px 2px 20px 0px rgba(151,151,194,0.13), inset 1px 1px 0px 0px #FFFFFF;
    border-radius: 10px;
    text-align: left;

    & .desc-show {
      font-size: 14px;
      font-weight: 300;
      color: #404040;
      line-height: 28px;
    }
    & .desc-up {
      font-size: 14px;
      font-weight: 300;
      color: #404040;
      line-height: 28px;
      display: -webkit-box;
      -webkit-box-orient: vertical;  //上下垂直
      -webkit-line-clamp: 4;  //自定义行数
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  & .header-action {
    position: absolute; right: 12px; bottom: 18px;
    text-align: right;
    & .header-text {
      font-size: 14px;
      font-weight: 500;
      color: #428AFF;
      margin-right: 4px;
    }
    & i {
      display: inline-block;
      font-size: 12px;
      color: #428AFF;
      transform: scale(0.7);
      transition: transform 0.3s ease;
      &.foucs {
        transform: rotateZ(180deg) scale(0.7) translateY(1px);
      }
    }
  }

}
</style>
